import { MouseEvent } from 'react';
import { isWindows } from 'app/shared/utils/system';

export const isCmdCtrlClick = (e: MouseEvent): boolean =>
  e.metaKey || (isWindows() && e.ctrlKey);
